import React from 'react';
import PropTypes from 'prop-types';
import { withStateHandlers, withProps, compose, lifecycle } from 'recompose';
import classnames from 'classnames';
import isEqual from 'lodash/isEqual';

import { withSearchHandler, withModalStateHandlers } from 'decorators';
import { ModalClose } from 'components/core/Modal';
import { Button } from 'components/core/Button';
import { Section } from 'components/core/Page';
import { StaticMap } from 'components/core/StaticMap';
import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import { Search } from 'components/svg';

import './SearchRail.scss';

export const enhance = compose(
	withProps({
		additionalSearchParams: {
			informedSearch: true,
		},
	}),
	withSearchHandler,
	withModalStateHandlers,
	withStateHandlers(({ queryParams }) => ({ filterParams: queryParams }), {
		handleQueryParamChange: (state, props) => (params) => {
			// if on a large screen apply filters immediately
			if (props.isLarge) {
				props.onSearchParamChange(params);
			}

			return {
				filterParams: params,
			};
		},
		handleApplyFilters: (state, props) => () => {
			props.onSearchParamChange(state.filterParams);
			const element = document.querySelector('.serp-container');
			if (element) {
				// 130 is the height of the sticky search bar
				window.scrollTo({
					top: element.offsetTop - 130,
					behavior: 'smooth',
				});
			}
		},
		updateParams: () => (filterParams) => ({ filterParams }),
	}),
	lifecycle({
		componentDidUpdate(prevProps) {
			if (!isEqual(prevProps.queryParams, this.props.queryParams)) {
				this.props.updateParams(this.props.queryParams);
			}
		},
	})
);

export function SearchRail({
	openInteractiveMap,
	children,
	filtersShowing,
	closeFilters,
	handleQueryParamChange,
	filterParams,
	handleApplyFilters,
	handleSearch,
	informedSearch,
}) {
	return (
		<div className={classnames('search-rail', { showing: filtersShowing })}>
			<div className="rail-content">
				{informedSearch && (
					<Section className="rail-search">
						<SearchBox
							inputLabel="Refine your search"
							handleSearch={handleSearch}
							id="informed-search-box"
							buttonIcon={true}
							buttonText=""
						/>
						<StickySearchBar
							triggerId="informed-search-box"
							handleSearch={handleSearch}
						/>
					</Section>
				)}
				{filtersShowing && (
					<ModalClose
						onClick={closeFilters}
						className="close-button"
					/>
				)}

				<StaticMap className="rail-static-map">
					<Button
						className=" view-map"
						onClick={openInteractiveMap}
					>
						Compare prices on map
					</Button>
				</StaticMap>

				{React.cloneElement(children, {
					queryParams: filterParams,
					onFilter: handleQueryParamChange,
				})}
			</div>
			<div className={classnames('apply-all-filters')}>
				<Button onClick={handleApplyFilters}>Apply</Button>
			</div>
		</div>
	);
}

SearchRail.propTypes = {
	filtersShowing: PropTypes.bool,
	openInteractiveMap: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired,
	closeFilters: PropTypes.func,
	filterParams: PropTypes.object,
	handleQueryParamChange: PropTypes.func,
	handleApplyFilters: PropTypes.func.isRequired,
	handleSearch: PropTypes.func.isRequired,
	informedSearch: PropTypes.bool
};

export default enhance(SearchRail);
